import { useEffect, useImperativeHandle, useState } from 'react';

import { InputField } from '@ravago/shared/radiance/components/input-field/components/InputField/InputField';
import { useTranslations } from '@ravago/shared/translations/client';

import useDebounce from '../../../../hooks/use-debounce';

const UPDATE_FILTERS_TIMEOUT_MS = 500;

export interface ProductCustomizableTableHandle {
   clear: () => void;
}

interface Props {
   disabled: boolean;
   onUpdateSearchFilter: (searchString: string) => void;
}

export const ProductCustomizableTableSearchFilter = ({ ref, disabled, onUpdateSearchFilter }: Props & { ref?: React.RefObject<ProductCustomizableTableHandle | null> }) => {
   const translate = useTranslations();

   const [searchString, setSearchString] = useState('');
   const [manuallyTriggeredOnUpdateSearchFilter, setManuallyTriggeredOnUpdateSearchFilter] = useState(true);
   const debouncedSearchString = useDebounce(searchString, UPDATE_FILTERS_TIMEOUT_MS);

   useEffect(() => {
      if (manuallyTriggeredOnUpdateSearchFilter) {
         return;
      }
      onUpdateSearchFilter(debouncedSearchString);
   }, [debouncedSearchString, onUpdateSearchFilter]);

   const handleInputFieldChange = (value: string) => {
      setManuallyTriggeredOnUpdateSearchFilter(false);
      setSearchString(value);
   };

   const handleInputFieldClear = () => {
      setManuallyTriggeredOnUpdateSearchFilter(true);
      setSearchString('');

      onUpdateSearchFilter('');
   };

   useImperativeHandle(ref, () => ({
      clear() {
         handleInputFieldClear();
      }
   }));

   return (
      <InputField
         label={translate('product-customizable-table-search-filter.search')}
         value={searchString}
         disabled={disabled}
         clearable
         id="table-search-filter__search-input"
         onChange={handleInputFieldChange}
         onClear={handleInputFieldClear}
         data-testid="table-search-filter__search-input"
      />
   );
};
